const parseInvestors = (investors) => (!investors ? [] : investors.split(', '));

export default parseInvestors;
